var _style, _symbol, _defs, _defs2, _defs3, _defs4, _defs5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingTableMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 507",
    style: {
      enableBackground: "new 0 0 375 507"
    },
    xmlSpace: "preserve",
    className: "loading-table-mobile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DDDDDD;}\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol",
    viewBox: "-187.5 -42.8 375 85.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230_3_",
    className: "st0",
    d: "M-144,15.1h122.8c0.5,0,0.9-0.9,0.9-2V4.3c0-1.1-0.4-2-0.9-2H-144c-0.5,0-0.9,0.9-0.9,2 v8.8C-145,14.2-144.5,15.1-144,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231_6_",
    className: "st0",
    d: "M111.6,42.8H166c1.9,0,3.4-0.9,3.4-2v-8c0-1.1-1.5-2-3.4-2h-54.4c-1.9,0-3.4,0.9-3.4,2 v8C108.2,41.8,109.7,42.8,111.6,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231_5_",
    className: "st0",
    d: "M41.1,42.8h54.4c1.9,0,3.4-0.9,3.4-2v-8c0-1.1-1.5-2-3.4-2H41.1c-1.9,0-3.4,0.9-3.4,2v8 C37.7,41.8,39.2,42.8,41.1,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235_3_",
    className: "st0",
    d: "M90.4,8.2H167c1.2,0,2.3-1.1,2.3-2.4V-7.6c0-1.3-1-2.4-2.3-2.4H90.4 c-1.2,0-2.3,1.1-2.3,2.4V5.8C88.2,7.2,89.2,8.2,90.4,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237_3_",
    className: "st0",
    d: "M-143-6.8h53c1.1,0,2-0.9,2-2v-8c0-1.1-0.9-2-2-2h-53c-1.1,0-2,0.9-2,2v8 C-145-7.8-144.1-6.8-143-6.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228_3_",
    className: "st0",
    d: "M-125.5,38.7h41c1.1,0,2-0.9,2-2v-4c0-1.1-0.9-2-2-2h-41c-1.1,0-2,0.9-2,2v4 C-127.5,37.8-126.6,38.7-125.5,38.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_3_",
    className: "st0",
    cx: -138,
    cy: 35.2,
    r: 7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317_3_",
    x: -187.5,
    y: -42.8,
    className: "st0",
    width: 375,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123_3_",
    className: "st0",
    d: "M-165,2.8h-8c-1.4,0-2.5,1.1-2.5,2.5l0,0v8c0,1.4,1.1,2.5,2.5,2.5h8c1.4,0,2.5-1.1,2.5-2.5 v-8C-162.5,3.8-163.6,2.8-165,2.8L-165,2.8z M-173,14.8c-0.8,0-1.5-0.7-1.5-1.5l0,0v-8c0-0.8,0.7-1.5,1.5-1.5l0,0h8 c0.8,0,1.5,0.7,1.5,1.5l0,0v8c0,0.8-0.7,1.5-1.5,1.5l0,0H-173z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 17,
    width: 375,
    height: 85.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 375,
    height: 85.5,
    id: "XMLID_1_",
    x: -187.5,
    y: -42.8,
    transform: "matrix(1 0 0 -1 187.5 59.75)",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 120,
    width: 375,
    height: 85.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 375,
    height: 85.5,
    x: -187.5,
    y: -42.8,
    transform: "matrix(1 0 0 -1 187.5 162.75)",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    y: 223,
    width: 375,
    height: 85.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 375,
    height: 85.5,
    x: -187.5,
    y: -42.8,
    transform: "matrix(1 0 0 -1 187.5 265.75)",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    y: 320,
    width: 375,
    height: 85.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_8_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 375,
    height: 85.5,
    x: -187.5,
    y: -42.8,
    transform: "matrix(1 0 0 -1 187.5 362.75)",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    y: 422,
    width: 375,
    height: 85.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_10_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 375,
    height: 85.5,
    x: -187.5,
    y: -42.8,
    transform: "matrix(1 0 0 -1 187.5 464.75)",
    style: {
      overflow: "visible"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingTableMobile);
export default __webpack_public_path__ + "static/media/loading-table-mobile.8383f91a82f0a6f8f27beebf65abc688.svg";
export { ForwardRef as ReactComponent };